import React from 'react';
import UndoIcon from '@mui/icons-material/Undo';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

const digitClass =
  'p-3 rounded-lg font-bold text-lg text-brand-gold-200 w-[100%] shadow-sm bg-gradient-to-b from-brand-blue-500 to-brand-blue-700 hover:from-brand-blue-600 hover:to-brand-blue-800 active:scale-95 transition-all disabled:opacity-40 disabled:hover:from-brand-blue-500 disabled:hover:to-brand-blue-700 disabled:active:scale-100 disabled:cursor-not-allowed';

const actionClass =
  'p-3 rounded-lg w-[100%] shadow-sm bg-gradient-to-b from-rose-500 to-red-700 hover:from-rose-600 hover:to-red-800 active:scale-95 transition-all disabled:opacity-40 disabled:hover:from-rose-500 disabled:hover:to-red-700 disabled:active:scale-100 disabled:cursor-not-allowed';

function Numpad(props) {


  return (
    <>
    {props.numpadvisible &&
    <div className='numpad'>
      <div className='flex flex-row w-[100%] space-x-1'>
        <button disabled={props.disabled} className={digitClass} value="1" onClick={props.handleNumpad}>1</button>
        <button disabled={props.disabled} className={digitClass} value="2" onClick={props.handleNumpad}>2</button>
        <button disabled={props.disabled} className={digitClass} value="3" onClick={props.handleNumpad}>3</button>
      </div>
      <div className='flex flex-row w-[100%] space-x-1'>
        <button disabled={props.disabled} className={digitClass} value="4" onClick={props.handleNumpad}>4</button>
        <button disabled={props.disabled} className={digitClass} value="5" onClick={props.handleNumpad}>5</button>
        <button disabled={props.disabled} className={digitClass} value="6" onClick={props.handleNumpad}>6</button>
      </div>
      <div className='flex flex-row w-[100%] space-x-1'>
        <button disabled={props.disabled} className={digitClass} value="7" onClick={props.handleNumpad}>7</button>
        <button disabled={props.disabled} className={digitClass} value="8" onClick={props.handleNumpad}>8</button>
        <button disabled={props.disabled} className={digitClass} value="9" onClick={props.handleNumpad}>9</button>
      </div>
      <div className='flex flex-row w-[100%] space-x-1'>
        <button className={actionClass + ' flex flex-row items-center justify-center gap-1 text-brand-gold-200'} onClick={props.handleCancelLastest}><UndoIcon fontSize="small" />
        <span className='md:block hidden text-sm font-semibold'>ยกเลิกรายการล่าสุด</span>
        </button>
        <button disabled={props.disabled} className={digitClass} value="0" onClick={props.handleNumpad}>0</button>
        <button disabled={props.disabled} className={actionClass + ' flex items-center justify-center text-brand-gold-200'} onClick={props.handleundo} ><KeyboardBackspaceIcon /></button>
      </div>
    </div>
      }
    </>
  );
}
export default Numpad
